import React from 'react';
import mapInterface from '../../../mapboxgl/mapInterface';

class RadarMarker extends React.Component {
  constructor(props) {
    super(props);

    this.markerElement = null;
  }

  componentDidMount() {
    const {
      data,
      data: { radarPos, panoNorthView },
    } = this.props;
    this.markerElement = mapInterface.createRadarMarker(data);
    this.markerElement &&
      mapInterface.rotateRadarMarker(
        this.markerElement,
        radarPos,
        panoNorthView
      );
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      data: { radarPos, panoNorthView },
    } = this.props;
    mapInterface.rotateRadarMarker(this.markerElement, radarPos, panoNorthView);
  }

  componentWillUnmount() {
    mapInterface.deleteMarker(this.markerElement);
  }

  render() {
    return null;
  }
}

export default RadarMarker;
